module.exports = __webpack_public_path__ + "img/janine_m.6192c5e4.png";